/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo, useState } from "react";
import { useGoogleCloudProjectsQuery } from "~/generated/graphql";
import { isNotNil } from "~/tools";
import { GcpProjectSidebarSelector } from "./GcpProjectSidebarSelector";

type Props = {
  onSubmit: (value: string) => void;
  onClose: () => void;
  isOpen: boolean;
  excludeItems?: string[];
};

const FETCH_LIMIT = 20;

export function GcpProjectSelector({
  onSubmit,
  onClose,
  isOpen,
  excludeItems = [],
}: Props) {
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");

  const { data, loading } = useGoogleCloudProjectsQuery({
    variables: { page, limit: FETCH_LIMIT, query: search },
  });

  const selectorOptions = useMemo(() => {
    const projects = data?.gcpProjects?.projects?.filter(isNotNil) ?? [];
    return projects.map((project) => ({
      label: project,
      value: project,
    }));
  }, [data]);

  return (
    <GcpProjectSidebarSelector
      hasIcon
      hasSubtitle
      limit={20}
      isOpen={isOpen}
      options={selectorOptions}
      name="Google Cloud Project"
      page={page}
      setPage={setPage}
      count={data?.gcpProjects?.count ?? 0}
      setSearch={setSearch}
      isLoading={loading}
      excludeItems={excludeItems}
      onClick={onClose}
      onSubmit={onSubmit}
    />
  );
}
